<template>
  <v-main>
    <v-container grid-list-md fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <v-card class="elevation-12">

            <v-toolbar dark color = "primary">
              <v-toolbar-title>{{$t("No password to activate")}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              {{$t("No password to activate, please request a new password.")}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" to="/">{{$t("Login")}}</v-btn>
            </v-card-actions>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
// This view is used when user activates a new password by pressing a link in an email - BUT the link is too old.
export default {
}
</script>
